import type { Encoding } from '@studio/js-utils/time';

/** NATS connection timeout (10 seconds). */
export const NatsTimeout: Encoding.MILLISECONDS = 10e3;

/** Local storage key. */
export const NatsUserKey = 'studio-nk';
